import {User} from "../user/user";
import {TypeDebit} from "../contrat/contrat";
import {ListItem} from "@domain/common/list-view/list-item";

/**
 * Modèle représentant un compte associé à un contrat
 */
export class Compte implements ListItem {
    idCarte: string;
    idContrat: number;
    idUser: number;
    libelle: string;
    numCarteClair: string;
    actif: boolean;
    typeDebit: TypeDebit;
    typeCarte: TypeCarte;
    typeCartePaiement: TypeCartePaiement;
    dateFin: Date;
    user: User;

    constructor(dto: any) {
        if (dto) {
            this.idCarte = dto.idCarte;
            this.idContrat = dto.idContrat;
            this.idUser = dto.idUser;
            this.libelle = dto.libelle;
            this.numCarteClair = dto.numCarteClair;
            this.actif = dto.actif;
            this.typeDebit = dto.typeDebit;
            this.typeCarte = dto.typeCarte;
            this.typeCartePaiement = dto.typeCartePaiement;
            this.dateFin = dto.dateFin;
            this.user = dto.user;
        }
    }

    /**
     * Récupération de l'identifiant de l'objet
     * @returns L'identifiant du compte
     */
    getKey(): number | string {
        return this.idCarte;
    }
}

/**
 * Enum des types de carte
 */
export enum TypeCarte {
    AFFAIRE = "AFFAIRE",
    PERSO = "PERSO"
}

export enum TypeCartePaiement {
    INDETERMINE = "INDETERMINE",
    AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
    DINERS_CLUB = "DINERS_CLUB",
    DISCOVER = "DISCOVER",
    EUROCARD = "EUROCARD",
    MASTERCARD = "MASTERCARD",
    VISA = "VISA"
}
